import PropTypes from 'prop-types';
import React from 'react';

import { isEmpty } from '@/helpers/utils';

import StandardTile from './lib/StandardTile';
import VideoTile from './lib/VideoTile';

/**
 * VideoTestimonialTile.
 */

const VideoTestimonialTile = ({
  image,
  content,
  logo,
  personName,
  companyName,
  video,
  bigImage,
}) => {
  if (!isEmpty(video) || !isEmpty(bigImage)) {
    return (
      <VideoTile
        {...{
          content,
          logo,
          personName,
          companyName,
          video,
          bigImage,
        }}
      />
    );
  }
  // standard testimonial
  return (
    <StandardTile {...{ image, content, logo, personName, companyName }} />
  );
};

VideoTestimonialTile.propTypes = {
  content: PropTypes.string.isRequired,
  /** Image. */
  image: PropTypes.object,
  /** Company logo. */
  logo: PropTypes.object,
  /** Company logo alt. */
  personName: PropTypes.string,
  /** Person role in company */
  companyName: PropTypes.string.isRequired,
  /** Testimonial Video */
  video: PropTypes.string,
  /** Testimonial big image */
  bigImage: PropTypes.object,
};

VideoTestimonialTile.defaultProps = {
  image: null,
  logo: null,
  personName: '',
  video: '',
  bigImage: {},
};

export default VideoTestimonialTile;
